<span class="list-label" translate>PHONE_NUMBER</span>

<mat-checkbox class="select-all"
              [formControl]="selectAllMsisdnsCheckbox"
              [indeterminate]="selectAllMsisdnsCheckbox.value === null"
              (ngModelChange)="changeSelectAllState($event)">
</mat-checkbox>
<span class="label-select-all" translate>REPORTS.SELECT_ALL</span>

<div class="checkbox-wrapper">
  <div *ngFor="let item of msisdns" class="checkbox-row">
    <mat-checkbox (change)="changeMsisdnsForEvent($event)"
                  [value]="item"
                  [checked]="isChecked(item)">
    </mat-checkbox>
    <cc-item-msisdn [msisdn]="item"></cc-item-msisdn>
  </div>
</div>

